import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useLoja } from './LojaContext';
import { Button } from '../../components/ui/button';
import { Card } from '../../components/ui/card';
import { Package, ArrowLeft, ShoppingCart, Plus, Minus } from 'lucide-react';
import { toast } from 'sonner';

export default function LojaProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { API, addToCart } = useLoja();
  const [product, setProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/products/${id}`).then(r => setProduct(r.data))
      .catch(() => toast.error('Produto não encontrado'))
      .finally(() => setLoading(false));
  }, [id, API]);

  if (loading) return <div className="text-center text-slate-400 py-16">Carregando...</div>;
  if (!product) return <div className="text-center text-slate-400 py-16">Produto não encontrado</div>;

  return (
    <div>
      <button onClick={() => navigate('/loja')} className="text-sm text-slate-400 hover:text-white mb-4 inline-flex items-center gap-1">
        <ArrowLeft className="w-4 h-4" /> Voltar
      </button>
      <Card className="bg-slate-900 border-slate-800 overflow-hidden">
        <div className="grid md:grid-cols-2 gap-6">
          <div className="aspect-square bg-gradient-to-br from-slate-800 to-slate-900 flex items-center justify-center">
            {product.image_url ? <img src={product.image_url} alt={product.name} className="w-full h-full object-cover" /> : <Package className="w-24 h-24 text-slate-600" />}
          </div>
          <div className="p-6 flex flex-col">
            <h1 className="text-2xl font-bold mb-2">{product.name}</h1>
            <p className="text-slate-400 mb-6">{product.description}</p>
            <div className="text-4xl font-black text-fuchsia-400 mb-6">R$ {product.price.toFixed(2)}</div>
            <div className="flex items-center gap-3 mb-6">
              <span className="text-sm text-slate-400">Quantidade:</span>
              <div className="flex items-center border border-slate-700 rounded-lg">
                <button onClick={() => setQty(Math.max(1, qty - 1))} className="px-3 py-2 hover:bg-slate-800"><Minus className="w-3 h-3" /></button>
                <span className="px-4 py-2 min-w-[40px] text-center">{qty}</span>
                <button onClick={() => setQty(qty + 1)} className="px-3 py-2 hover:bg-slate-800"><Plus className="w-3 h-3" /></button>
              </div>
            </div>
            <Button size="lg" onClick={() => { addToCart(product, qty); toast.success('Adicionado ao carrinho'); navigate('/loja/cart'); }} className="bg-fuchsia-500 hover:bg-fuchsia-600 text-white">
              <ShoppingCart className="w-5 h-5 mr-2" /> Adicionar ao Carrinho
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
